import api from "../../services/api";
import {
  ADD_COURSE_REVIEW_FAILURE,
  ADD_COURSE_REVIEW_REQUEST,
  ADD_COURSE_REVIEW_SUCCESS,
  ADD_INSTRUCTOR_REVIEW_FAILURE,
  ADD_INSTRUCTOR_REVIEW_REQUEST,
  ADD_INSTRUCTOR_REVIEW_SUCCESS,
  GET_COURSE_REVIEWS_FAILURE,
  GET_COURSE_REVIEWS_REQUEST,
  GET_COURSE_REVIEWS_SUCCESS,
  GET_INSTRUCTOR_REVIEWS_FAILURE,
  GET_INSTRUCTOR_REVIEWS_REQUEST,
  GET_INSTRUCTOR_REVIEWS_SUCCESS,
} from "./ActionType";

const addCourseReviewRequest = () => {
  return {
    type: ADD_COURSE_REVIEW_REQUEST,
  };
};

const addCourseReviewSuccess = (review) => {
  return {
    type: ADD_COURSE_REVIEW_SUCCESS,
    payload: review,
  };
};

const addCourseReviewFailure = (error) => {
  return {
    type: ADD_COURSE_REVIEW_FAILURE,
    payload: error,
  };
};

export const addCourseReview = (courseId, reviewData) => async (dispatch) => {
  dispatch(addCourseReviewRequest());
  try {
    const response = await api.post(`/courses/${courseId}/reviews`, reviewData);
    const review = response.data;
    dispatch(addCourseReviewSuccess(review));
  } catch (error) {
    dispatch(addCourseReviewFailure(error.response.data));
  }
};

const addInstructorReviewRequest = () => {
  return {
    type: ADD_INSTRUCTOR_REVIEW_REQUEST,
  };
};

const addInstructorReviewSuccess = (review) => {
  return {
    type: ADD_INSTRUCTOR_REVIEW_SUCCESS,
    payload: review,
  };
};

const addInstructorReviewFailure = (error) => {
  return {
    type: ADD_INSTRUCTOR_REVIEW_FAILURE,
    payload: error,
  };
};
export const addInstructorReview =
  (instructorId, reviewData) => async (dispatch) => {
    dispatch(addInstructorReviewRequest());
    try {
      const response = await api.post(
        `/instructors/${instructorId}/reviews`,
        reviewData
      );
      const review = response.data;
      dispatch(addInstructorReviewSuccess(review));
    } catch (error) {
      dispatch(addInstructorReviewFailure(error.response.data));
    }
  };

const getInstructorReviewsRequest = () => {
  return {
    type: GET_INSTRUCTOR_REVIEWS_REQUEST,
  };
};

const getInstructorReviewsSuccess = (reviews) => {
  return {
    type: GET_INSTRUCTOR_REVIEWS_SUCCESS,
    payload: reviews,
  };
};

const getInstructorReviewsFailure = (error) => {
  return {
    type: GET_INSTRUCTOR_REVIEWS_FAILURE,
    payload: error,
  };
};

export const getInstructorReviews =
  (instructorId, page = 0) =>
  async (dispatch) => {
    dispatch(getInstructorReviewsRequest());
    try {
      const response = await api.get(
        `/instructors/${instructorId}/reviews?page=${page}`
      );
      const reviews = response.data;
      dispatch(getInstructorReviewsSuccess(reviews));
    } catch (error) {
      dispatch(getInstructorReviewsFailure(error.response.data));
    }
  };

const getCourseReviewsRequest = () => {
  return {
    type: GET_COURSE_REVIEWS_REQUEST,
  };
};

const getCourseReviewsSuccess = (reviews) => {
  return {
    type: GET_COURSE_REVIEWS_SUCCESS,
    payload: reviews,
  };
};

const getCourseReviewsFailure = (error) => {
  return {
    type: GET_COURSE_REVIEWS_FAILURE,
    payload: error,
  };
};

export const getCourseReviews =
  (courseId, page = 0) =>
  async (dispatch) => {
    dispatch(getCourseReviewsRequest());
    try {
      const response = await api.get(
        `/courses/${courseId}/reviews?page=${page}`
      );
      const reviews = response.data;
      dispatch(getCourseReviewsSuccess(reviews));
    } catch (error) {
      dispatch(getCourseReviewsFailure(error.response.data));
    }
  };
